/**
 * WorkstationsSoftwarePage — consola de software del parque, dentro del módulo
 * de Estaciones de trabajo.
 *
 * Es el MISMO `SoftwarePackagesPanel` que vive en Agente CMDB → Paquetes. No
 * hay una segunda implementación: el módulo de equipos solo le da un sitio
 * propio, para no tener que salir a Administración cada vez que hay que
 * instalar o actualizar algo en los PCs.
 */

import React from 'react';
import SoftwareConsole from './SoftwareConsole';

export default function WorkstationsSoftwarePage({ companyId }) {
  return (
    <div style={{ padding: '1rem 1.25rem 1.25rem' }}>
      <SoftwareConsole companyId={companyId} />
    </div>
  );
}
